export default function newApprovalApproved() {
    return {
        type: newApprovalApproved.type,
    };
}

newApprovalApproved.type = 'NEW_APPROVAL_APPROVED';
